module.exports = "query productSearchBasic($vendorId:String){productSearchBasic(vendorId:$vendorId){id title}}"